import React from 'react'
import { makeStyles } from '@mui/styles'
import ThemeInterface from '@/theme-interface'
import lang from '@/lang'
import Info from '@/modules/base/components/hints/info'

const useStyles = makeStyles((theme: ThemeInterface) => ({
  description: {
    '& a': {
      color: theme.palette.primary.main,
    },
  },
}))

const LegacyPlanHint = () => {
  const classes = useStyles()
  const { title, description } = lang.upgrade.wizard.selection.legacyPlanHint

  return (
    <div data-qs-id='subscription-selection-legacy-plan-hint'>
      <Info title={title}>
        <span className={classes.description} dangerouslySetInnerHTML={{ __html: description }} />
      </Info>
    </div>
  )
}

export default LegacyPlanHint
